module.exports = __webpack_public_path__ + "img/20220416_145544.ceb6581c.jpg";